(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('CompaniesNewController', companiesnew);

  companiesnew.$inject = ['$http', '$state', 'ngTableParams', 'LangService', 'Upload', '$timeout', '$rootScope'];

  function companiesnew ($http, $state, ngTableParams, LangService, Upload, $timeout, $rootScope) {
    var vm = this;
    LangService
      .getPageLabels({ 'page': 'menu.newComp' })
      .$promise
      .then(function (data) {
        vm.labels = data.lang;
      });
    	vm.saveCompany = saveCompany
    	vm.uploadPhoto = uploadPhoto
    	vm.new_company = {
    		view_data: {
    			'title': '',
    			'logo': '',
    			'logo_login': ''
    		}
    	}
    function saveCompany () {
      vm.new_company.view_data.title = vm.new_company.name;

      $http.post(apiUrl + '/companies', {
        name: vm.new_company.name,
        domain: vm.new_company.domain,
        view_data: vm.new_company.view_data
      }).then(function (response) {
            	if ($rootScope.checkMenuAccess('lord')) {
            		$rootScope.user_data.companies.push(response.data)
            	}
        $state.reload();
      }, function (error) { console.log(error) });
	    };
	   function uploadPhoto (file, index, key) {
         	if (file) {
         		if (file.length) {
	         		file.upload = Upload.upload({
		                url: baseUrl + '/whitelabel-upload',
		                fields: { key: key },
		                file: file
		            });

		            file.upload.then(function (response) {
		                $timeout(function () {
		                 	vm.new_company.view_data[key] = response.data.url;
		                });
		            }, function (response) {
		                if (response.status > 0) { console.log(response.status + ': ' + response.data); }
		            });
            	}
         	}
    };
  }
})();
